"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memberships_limits = exports.memberships = exports.membership = exports.partnerships = exports.partnership = void 0;
exports.partnership = "/api/loyalty/partnerships/{code}";
exports.partnerships = "/api/loyalty/partnerships{?brand,region,currency}";
exports.membership = "/api/loyalty/memberships/{code}";
exports.memberships = "/api/loyalty/memberships{?brand,region,currency}";
exports.memberships_limits = "/api/loyalty/memberships/limits{?brand,customer_id,membership_code,membership_number}";
